// docs: https://github.com/altostra/type-validations#readme
import { anyOf, arrayOf, maybe, objectOf } from "@altostra/type-validations";
import { nullOrUndefined, number, string } from "@altostra/type-validations/lib/primitives";

export const isCompaniesCompanyIdCustomDomainsDomainTypeDomainIdResult = objectOf({
  id: string,
  domain: string,
  status: string,
  type: string,
  created_at: maybe(anyOf(number, nullOrUndefined)),
  expires_at: maybe(anyOf(number, nullOrUndefined)),
  dns_results: maybe(
    arrayOf(
      objectOf({
        type: string,
        name: string,
        value: string,
      })
    )
  ),
});
